import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Loader({ names }) {
  const [done, setDone] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const start = Date.now();
    const dur = 2200;
    const id = setInterval(() => {
      const p = Math.min(1, (Date.now() - start) / dur);
      setCount(Math.floor(p * 100));
      if (p >= 1) {
        clearInterval(id);
        setTimeout(() => setDone(true), 450);
      }
    }, 60);
    const hardStop = setTimeout(() => setDone(true), dur + 1200);
    return () => {
      clearInterval(id);
      clearTimeout(hardStop);
    };
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="loading-screen"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-deep-black text-ivory"
          exit={{ y: "-100%" }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
        >
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className="mb-6 text-xs uppercase tracking-[0.5em] text-gold"
          >
            Nuestra Boda
          </motion.p>
          <div className="overflow-hidden">
            <motion.h1
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1], delay: 0.1 }}
              className="font-serif text-5xl font-light tracking-tight md:text-7xl"
            >
              {names}
            </motion.h1>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
